export const mutations = {
  STORE_INTERCHANGES(state, interchanges) {
    state.interchanges = interchanges;
  },
  STORE_INTERCHANGE_UPDATE(state, interchangeId) {
    let Interchange = state.interchanges.find(function(interchange) {
      return interchange.id === interchangeId;
    });
    state.systemInterchange = Interchange;
  }
};
export default mutations;



// WEBPACK FOOTER //
// ./src/vuex/modules/interchanges/mutations.js